// The player and the Rhythm Lab: the same screen. Top to bottom: the bar, the stage, the fix row (the lab has its band instead), the
// transport and the practice row. Big mode keeps only the numeral and the phrase bar (DESIGN §2); landscape on a phone does the same in CSS.

import { BackIcon, BigIcon, CloseIcon, MenuIcon } from './icons.js';
import { Band } from './band.js';
import { useEngineState } from './engine-state.js';
import { ConfirmRow, FixRow } from './fixes.js';
import { PracticeRow } from './practice.js';
import { Stage } from './stage.js';
import { TapsBar } from './taps.js';
import { Problems } from './toast.js';
import { Transport } from './transport.js';
import { leavePlayer, openSheet, toggleBig, ui } from './ui.js';

export function Player() {
  const s = useEngineState();
  const { big } = ui.use();
  const lab = s.source === 'lab';
  return (
    <div class="screen play" data-big={big ? '' : undefined} data-lab={lab ? '' : undefined} data-asking={!lab && s.auto.awaiting && !s.truthMode ? '' : undefined}>
      <header class="bar chrome">
        <button type="button" class="btn icon" aria-label="Back to Home" onClick={leavePlayer}><BackIcon /></button>
        <h1 class="bar-title">{s.track?.name ?? (s.status === 'decoding' ? 'Opening…' : '')}</h1>
        <button type="button" class="btn icon" aria-label="Big mode" aria-pressed={big} onClick={toggleBig}><BigIcon /></button>
        <button type="button" class="btn icon" aria-label="Menu" aria-haspopup="dialog" onClick={() => openSheet('menu')}><MenuIcon /></button>
      </header>
      <Problems />
      <Stage />
      {!lab && <TapsBar />}
      <div class="lower chrome">
        {lab ? <Band /> : s.auto.awaiting && !s.truthMode ? <ConfirmRow /> : <FixRow />}
      </div>
      <div class="dock chrome">
        <Transport />
        <PracticeRow />
      </div>
      {big && <button type="button" class="btn icon big-exit" aria-label="Leave big mode" onClick={toggleBig}><CloseIcon /></button>}
    </div>
  );
}

